<template>
  <b-pagination
      @change="onChangePage"
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="meta.per_page"
  ></b-pagination>
</template>

<script>
export default {
  name: "Pagination",
  props: ['meta', 'onChangePage'],
  data() {
    return {
      currentPage: 1,
    }
  },
  computed: {
    totalRows() {
      return this.meta.total;
    }
  }
}
</script>

<style scoped>

</style>